import {createReducer, on} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../../../error/error-handling/product-management-error';
import {CatalogSummary, Product} from '../../../../../models/clare';
import {CreateProductActions} from './create-product.actions';

export const CREATE_PRODUCT_FEATURE_KEY = 'Create Product Feature';

export type CreateProductRequestStatus = 'idle' | 'pending' | 'success' | 'failure';

export interface CreateProductState {
  catalogs: CatalogSummary[];
  catalogsLoading: boolean;
  loading: boolean;
  addAnotherProduct: boolean;
  error: ProductManagementErrorInterface | undefined;
  createProductRequestId: string | undefined;
  createProductRequestStatus: CreateProductRequestStatus;
  createdProduct: Product | undefined;
}

export const initialCreateProductState: CreateProductState = {
  catalogs: [],
  catalogsLoading: false,
  loading: false,
  addAnotherProduct: false,
  error: undefined,
  createProductRequestId: undefined,
  createProductRequestStatus: 'idle',
  createdProduct: undefined,
};

export const createProductReducer = createReducer(
  initialCreateProductState,
  on(CreateProductActions.loadCatalogs, state => ({
    ...state,
    catalogs: [],
    catalogsLoading: true,
  })),
  on(CreateProductActions.loadCatalogsSuccess, (state, {catalogs}) => ({
    ...state,
    catalogs,
    catalogsLoading: false,
  })),
  on(CreateProductActions.loadCatalogsFailure, state => ({
    ...state,
    catalogs: [],
    catalogsLoading: false,
  })),
  on(CreateProductActions.createProduct, (state, {requestId}) => ({
    ...state,
    error: undefined,
    loading: true,
    createProductRequestId: requestId,
    createProductRequestStatus: 'pending' as const,
    createdProduct: undefined,
  })),
  on(CreateProductActions.createAnotherProduct, (state, {addAnotherProduct}) => ({
    ...state,
    addAnotherProduct,
  })),
  on(CreateProductActions.createProductSuccess, (state, {product, requestId}) => {
    if (state.createProductRequestId !== requestId) return state;

    return {
      ...state,
      loading: false,
      createProductRequestStatus: 'success' as const,
      createdProduct: product,
    };
  }),
  on(CreateProductActions.createProductFailure, (state, {error, requestId}) => {
    if (state.createProductRequestId !== requestId) return state;

    return {
      ...state,
      error,
      loading: false,
      createProductRequestStatus: 'failure' as const,
    };
  }),
  on(CreateProductActions.abandonCreateProductRequest, (state, {requestId}) => {
    if (state.createProductRequestId !== requestId) return state;

    return {
      ...state,
      loading: false,
      createProductRequestId: undefined,
      createProductRequestStatus: 'idle' as const,
      createdProduct: undefined,
    };
  })
);

export const getLoading = (state: CreateProductState) => state.loading;
export const getCatalogs = (state: CreateProductState) => state.catalogs;
export const getCatalogsLoading = (state: CreateProductState) => state.catalogsLoading;
export const getError = (state: CreateProductState) => state.error;
export const getAddAnotherProduct = (state: CreateProductState) => state.addAnotherProduct;
export const getCreateProductRequest = (state: CreateProductState) => ({
  requestId: state.createProductRequestId,
  status: state.createProductRequestStatus,
  product: state.createdProduct,
});
